import useApi from './useApi';

const useAuthService = () => {
  const { api } = useApi();

  const adminTypes = { platform: 'platform-admin-accounts', establishment: 'establishment-admin-accounts' };

  const postLoginToken = (values) => api({
    method: 'post',
    url: `/identity-access/v1/${adminTypes[values.adminType]}/token`,
    data: {
      grant_type: 'password',
      username: values.email,
      password: values.password,
    },
  });

  const postInitPasswordReset = ({ adminType, email }) => api({
    method: 'post',
    url: `/identity-access/v1/${adminTypes[adminType]}/${email}:initialize-password-reset`,
    data: {
      passwordResetUrl: `${process.env.REACT_APP_URL}/reset-password?type=${adminType}&token=:token`,
    },
  });

  const postFinalizePasswordReset = ({ password, adminType, token }) => api({
    method: 'post',
    url: `/identity-access/v1/${adminTypes[adminType]}/${token}:finalize-password-reset`,
    data: {
      password,
    },
  });

  return {
    postLoginToken,
    postInitPasswordReset,
    postFinalizePasswordReset,
  };
};

export default useAuthService;
